import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import webStyled from 'styled-components';

import { Text } from 'app/src/styles';
import * as colors from 'app/src/styles/colors';

export const Container = styled(View)`
  flex-direction: row;
  justify-content: stretch;
  height: 80vh;
`;

export const ContainerWithFlash = styled(View)`
`;

export const Column = styled(View)`
  flex: 1;
`;

export const BorderedContainer = styled(View)`
  flex: 1;
  margin: 10px;
  padding: 10px;
  border-color: black;
  border-width: 5px;
  border-style: solid;
  border-radius: 10px;
`;

export const Title = styled(Text)`
  font-size: 20px;
  font-weight: 600;
`;

export const Subtitle = styled(Text)`
  font-size: 20px;
`;

export const NoticeContainer = webStyled.div`
  display: flex;
  background-color: ${colors.elRed};
  min-height: 40px;
  border-radius: 4px;
  margin-top: 4px;
  margin-bottom: 4px;
  align-items: center;
  justify-content: space-around;

  ${props => props.notice ? `
    @keyframes blink-then-fade {
      0% { opacity: 0; }
      8% { opacity: 1; }
      16% { opacity: 0; }
      24% { opacity: 1; }
    }

    animation-duration: 6s;
    animation-name: blink-then-fade;
  ` : ''};

  opacity: 1;
`;

export const NoticeText = styled(Title)`
  color: white;
`;

export const NoticesSelectContainer = styled(View)`
  flex-direction: row;
  gap: 20px;
`;

export const Split = styled(View)`
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom-color: black;
  border-bottom-width: 2px;
  border-bottom-style: solid;
`;

export const SaleAssetContainer = styled(View)`
  min-height: 100px;
  flex-direction: row;
  background-color: ${props => props.active ? 'yellow' : 'none'};
  padding-bottom: 10px;
  border-width: 2px;
  border-style: solid;
  border-color: ${props => props.groupPosition ? 'blue' : 'white'};
  ${props => 'first' === props.groupPosition && (
    'border-bottom-color: white;'
  )}
  ${props => 'last' === props.groupPosition && (
    'border-top-color: white; padding-bottom: 0px; margin-bottom: 10px;'
  )}
  ${props => 'middle' === props.groupPosition && (
    'border-top-color: white; border-bottom-color: white;'
  )}
`;

export const StyledTextInput = webStyled.input`
  flex: 1;
`;

export const Field = styled(View)`
  flex-direction: row;
`;

export const Label = styled(Text)`
  margin-right: 10px;
  align-self: center;
`;

export const Value = styled(Text)`
  font-weight: 600;
`;

export const Going = styled(View)`
  background-color: orange;
  padding: 10px;
`;

export const GoingText = styled(Subtitle)`
  font-weight: 900;
  color: white;
`;

export const GOING_BUTTONS = [
  { status: 'Going Once', color: 'darkorange' },
  { status: 'Going Twice', color: 'purple' },
];

export const goingColor = saleAsset => (
  GOING_BUTTONS.find(({ status }) => status === saleAsset.biddingStatus)?.color
);

const ButtonContainer = styled(Pressable)`
  background-color: ${colors.elGreen}
  flex: 1;
  padding: 10px;
  align-items: center;
  justify-content: space-around;
`;

const ButtonLabel = styled(Text)`
  color: white;
  font-weight: 700;
`;

export const Button = props => {
  const { title, style, labelStyle, disabled } = props;
  let { color, onPress } = props;

  if (disabled) {
    onPress = () => {};
    color = colors.elGray;
  }

  return (
    <ButtonContainer
      onPress={onPress}
      style={{...style, backgroundColor: (color || colors.elGreen)}}
    >
      <ButtonLabel style={labelStyle}>{title}</ButtonLabel>
    </ButtonContainer>
  );
};
